export const MAIN_CONTENT_ROUTE_DATA_KEY: string = 'mainContent';
export const IS_PREVIEW_CONTENT: string = 'isPreviewContent';
